import Video from "twilio-video";

export const getGradient = (gradientData) => {
  const color_gradient = gradientData;

  return `linear-gradient(0deg, ${color_gradient[1] ?? color_gradient[0]} 0%, ${
    color_gradient[0]
  } 80%)`;
};

export const clearWaterCoolerRoom = async (setRoom) => {
  try {
    await setRoom((currentRoom) => {
      if (currentRoom && currentRoom.localParticipant.state === "connected") {
        currentRoom.localParticipant.tracks.forEach(function (
          trackPublication
        ) {
          trackPublication.track.stop();
          const attachedElements = trackPublication.track.detach();
          attachedElements.forEach((element) => element.remove());
        });
        currentRoom.disconnect();
        return null;
      } else {
        return currentRoom;
      }
    });
  } catch (e) {
    console.log(e);
  }
  return;
};

export const once = (func) => {
  let ran = false;
  let result;
  return function () {
    if (ran) return result;
    result = func.apply(this, arguments);
    ran = true;
    return result;
  };
};

export const connectRoom = async (audio, video, response) => {
  return await Video.connect(response.data.data.token, {
    audio: audio,
    video: video,
    name: response.data.data.channel.unique_name,
  })
    .then((response2) => {
      if (response2) {
        return response2;
      }
      return null;
    })
    .catch((error) => {
      console.log(error);
    });
};

export const scrollToTopOfTimeline = () => {
  let queryData = document.querySelector("#timeline-container");

  if (queryData) {
    queryData.scrollIntoView({ behavior: "smooth", block: "start" });
    return;
  }
};

export const debounce = (func) => {
  let timer;
  return function (...args) {
    const context = this;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      func.apply(context, args);
    }, 200);
  };
};

export const scrollToBottomOfWaterCooler = () => {
  let queryData = document.querySelector("#watercooler-showMessage");

  if (queryData) {
    queryData.scrollIntoView({ behavior: "smooth", block: "end" });
    return;
  }
};

export const scrollToBottom = () => {
  document.querySelector("#watercooler-showMessage").scrollIntoView(false);
};

/**
 * Makes plain text URLs in HTML content clickable
 * @param {string} htmlContent - The HTML content that may contain plain text URLs
 * @returns {string} - HTML content with URLs converted to clickable links
 */
export const makeUrlsClickable = (htmlContent) => {
  // Check if the content is not a string or is empty
  if (!htmlContent || typeof htmlContent !== 'string') return '';
  
  // Check if the content is already HTML-like
  const containsHtml = /<[a-z][\s\S]*>/i.test(htmlContent);
  
  // If it's plain text (no HTML), just use simple regex replacement
  if (!containsHtml) {
    const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;
    return htmlContent.replace(urlRegex, (url) => {
      const href = url.startsWith('www.') ? `http://${url}` : url;
      return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
  }
  
  // This regex finds URLs that are not already inside href, src, or other attributes
  try {
    // This regex splits the HTML into tags and text content
    const chunks = htmlContent.split(/(<[^>]*>)/g);
    
    const processedChunks = chunks.map(chunk => {
      // If this is an HTML tag, leave it as is
      if (chunk.startsWith('<') && chunk.endsWith('>')) {
        return chunk;
      }
      
      // For text content, replace URLs with links
      const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;
      return chunk.replace(urlRegex, (url) => {
        const beforeUrl = chunk.substring(0, chunk.indexOf(url));
        const quoteCount = (beforeUrl.match(/"/g) || []).length;
        
        if (quoteCount % 2 === 1) {
          return url;
        }
        
        const href = url.startsWith('www.') ? `http://${url}` : url;
        return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
      });
    });
    
    return processedChunks.join('');
  } catch (e) {
    console.error("Error processing URLs in HTML:", e);
    return htmlContent;
  }
};

/**
 * Truncates text to a specified max length and adds ellipsis if needed
 * @param {string} text - The text to truncate
 * @param {number} maxLength - The maximum length of text to show before truncating
 * @returns {string} - Truncated text with ellipsis if needed
 */
export const truncateText = (text, maxLength) => {
  if (!text || typeof text !== 'string') return '';
  
  if (text.length <= maxLength) return text;
  
  return text.substring(0, maxLength).trim() + '...';
};

/**
 * Extracts a filename from a URL, stripping common prefixes.
 * @param {string} url - The URL to extract the filename from
 * @returns {string} - The extracted filename
 */
export const extractFileName = (url) => {
  if (!url || typeof url !== 'string') return "Document";
  try {
    const decodedUrl = decodeURIComponent(url);
    const path = decodedUrl.split('?')[0];
    const parts = path.split('/');
    let fileName = parts[parts.length - 1];
    // Strip common S3 prefix if present (30+ chars UUID + 10+ digits timestamp-)
    const match = fileName.match(/^[a-zA-Z0-9]{30,}-[0-9]{10,}-(.+)$/);
    return match ? match[1] : fileName;
  } catch (e) {
    return "Document";
  }
};
